export const redemptionsFilterState = (fleetId, location) => {
  const { state } = location || {};
  const { searchKey = "" } = state || {};
  return {
    fleetId,
    startDate: null,
    endDate: null,
    dispensedTo: "all",
    redemptionStatus: "all",
    productCodes: null,
    searchKey,
    redemptionStation: {
      value: null,
      label: "All",
    },
    page: 1,
    perPage: 10,
  };
};
